import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { Reveal, Stagger, staggerItem } from "../components/Reveal";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { useSiteImages } from "../context/SiteImagesContext";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const { resolve } = useSiteImages();

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  return (
    <main data-testid="blog-page" className="pt-36 pb-28 min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-16">
          <p className="overline mb-6">Blog</p>
          <h1 className="font-display text-5xl md:text-6xl text-[#2D3732] leading-[1.02]">
            Organización médica y bienestar.
          </h1>
          <p className="text-[#4A554E] mt-6 leading-relaxed font-light max-w-xl">
            Ideas, consejos y reflexiones para que cuidar tu salud sea también un ejercicio de calma
            y orden.
          </p>
        </Reveal>

        <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p) => (
            <motion.article
              key={p.id}
              variants={staggerItem}
              data-testid={`blog-card-${p.slug}`}
              onClick={() => navigate(`/blog/${p.slug}`)}
              className="group cursor-pointer"
            >
              <div className="rounded-[1.75rem] overflow-hidden aspect-[4/3] mb-5">
                <img
                  src={resolve(`blog:${p.slug}`, p.cover)}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
                />
              </div>
              <div className="flex items-center gap-3 mb-3">
                <span className="overline text-[#8A9A6F]">{p.category}</span>
                <span className="text-xs text-[#9CA3AF]">· {p.read_time}</span>
              </div>
              <h2 className="font-display text-2xl text-[#2D3732] leading-snug group-hover:text-[#8A9A6F] transition-colors">
                {p.title}
              </h2>
              <p className="text-[#4A554E] text-sm mt-3 leading-relaxed font-light line-clamp-2">
                {p.excerpt}
              </p>
              <span className="inline-flex items-center gap-2 text-sm text-[#2D3732] mt-4 link-underline">
                Leer artículo <ArrowRight size={15} />
              </span>
            </motion.article>
          ))}
        </Stagger>
      </div>
    </main>
  );
}
